<template>
  <button
    id="show-modal"
    aria-label="show modal"
    class="my-link close button is-brightGreen is-inverted svg nav-arrow-green-15 right arrow"
    @click="showModal = true"
  >
    {{ $t("rawdata.viewAvailableData") }}
  </button>
  <ModalView
    v-if="showModal"
    @close="showModal = false"
  >
    <template #body>
      <div class="modal-box table px-4 -mt-8">
        <div class="h4 mt-4 pb-2">
          {{ landbase }} {{ $t("rawdata.variable") }}
        </div>
        <div
          v-for="(data, dIndex) in dataType"
          :key="`protocol-${landbase}-${dIndex}`"
        >
          <div
            v-if="data === 'Habitat'"
            class="habitat-section"
          >
            <hr>
          </div>
          <div class="h5 mt-2">
            {{ data }}
          </div>
          <div class="columns my-0 ">
            <div class="column is-4 py-1 font-bold">
              {{ $t("rawdata.variable") }}
            </div>
            <div class="column is-4 py-1">
              {{ $t("rawdata.currentAvailable") }}
            </div>
            <div class="column is-4 py-1">
              {{ $t("rawdata.publicReleaseDate") }}
            </div>
          </div>
          <div
            v-for="(item, iIndex) in dataCategoryOptions[landbase][data].detail"
            :key="`item-${landbase}-${iIndex}`"
            class="columns my-0"
          >
            <div class="column is-4 py-1">
              {{ item.name }}
            </div>
            <div class="column is-4 py-1">
              {{ item.start_year }} - {{ item.last_year }}
            </div>
            <div class="column is-4 py-1">
              {{ item.next_release }}
            </div>
          </div>
        </div>
      </div>
    </template>
  </ModalView>
</template>

<script setup lang="ts">
import ModalView from '@/components/ModalView.vue';
import { rawdataState } from '@/composables/state/rawdataApp';
import { dataType } from '@/config/rawdata.d';
import { ref } from 'vue';

const { dataCategoryOptions } = rawdataState();

defineProps({
  landbase: { type: String, required: true }
});

const showModal = ref(false);
</script>

  <style scoped>
.modal-box {
  &.table {
    width: 700px;
  }
  #show-modal {
    margin-top: -5px;
  }
  .title-space {
    margin-bottom: 20px; /* Adjust space after title */
  }
  .habitat-section {
    margin-top: 20px; /* Space before the Habitat section */
  }
  hr {
    margin-bottom: 20px; /* Space after the horizontal line */
  }
  @media screen and (max-width: 700px) {
    &.table {
      width: 95%;
      padding-top: 20px;
    }
    .close.button {
      left: 10px;
      top: -10px;
    }
    .modal-content {
      padding-top: 20px!important;
    }
  }
}
  </style>
